export default __webpack_public_path__ + "static/daeyoung.won-83375d678bf51849a318c1964ae49670.jpeg";